import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  List, ListItemButton, ListItemText,
} from '@mui/material'
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import { selectPortfolioFolderTree } from 'ducks/portfolioDocuments/selectors'
import { movePortfolioFolderRoutine } from 'ducks/portfolioDocuments/actions'
import { toast } from 'react-toastify'

const collectSubtreeIds = (node, acc = []) => {
  acc.push(node.id)
  ;(node.childFolders || []).forEach((c) => collectSubtreeIds(c, acc))
  return acc
}
const flatten = (nodes, depth = 0, acc = []) => {
  (nodes || []).forEach((n) => {
    acc.push({ id: n.id, name: n.name, depth })
    flatten(n.childFolders, depth + 1, acc)
  })
  return acc
}
const findNode = (nodes, id) => {
  for (const n of nodes || []) {
    if (n.id === id) return n
    const found = findNode(n.childFolders, id)
    if (found) return found
  }
  return null
}

export default function MoveFolderModal({ portfolioId, folder, onClose }) {
  const dispatch = useDispatch()
  const tree = useSelector(selectPortfolioFolderTree)

  const self = findNode(tree, folder.id)
  const blocked = new Set(self ? collectSubtreeIds(self) : [folder.id])
  const targets = flatten(tree).filter((f) => !blocked.has(f.id) && f.id !== folder.parentFolderId)

  const move = (parentFolderId, label) => {
    dispatch(movePortfolioFolderRoutine.trigger({ portfolioId, folderId: folder.id, parentFolderId }))
    toast.success(`Moved "${folder.name}" to ${label}`)
    onClose()
  }

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Move "{folder.name}"</DialogTitle>
      <DialogContent dividers>
        <p style={{ marginTop: 0, color: '#666', fontSize: 14 }}>Choose where to move this folder.</p>
        <List dense sx={{ maxHeight: 340, overflow: 'auto' }}>
          {folder.parentFolderId && (
            <ListItemButton onClick={() => move(null, 'the top level')}>
              <HomeOutlinedIcon style={{ fontSize: 18, color: '#888', marginRight: 10 }} />
              <ListItemText primary="Top level (no parent folder)" />
            </ListItemButton>
          )}
          {targets.map((f) => (
            <ListItemButton key={f.id} onClick={() => move(f.id, f.name)} sx={{ pl: 1 + f.depth * 2 }}>
              <FolderOutlinedIcon style={{ fontSize: 18, color: '#c9a99b', marginRight: 10 }} />
              <ListItemText primary={f.name} />
            </ListItemButton>
          ))}
          {targets.length === 0 && !folder.parentFolderId && (
            <p style={{ color: '#888' }}>There's nowhere else to move this folder to.</p>
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  )
}
